var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { staticClass: "pb-10" },
    [
      _c(
        "LoadingOverlay",
        { attrs: { hasData: !_vm.isLoading, loading: _vm.isLoading } },
        [
          _c(
            "p",
            { staticClass: "font-semibold w-max-content custom-title mt-1" },
            [_vm._v("Company Settings")]
          ),
          _c(
            "div",
            { staticClass: "bg-white shadowCard mt-6" },
            [_c("TabsWithRoutes", { attrs: { routeTabs: _vm.routeTabs } })],
            1
          ),
          _c("RouterView", {
            attrs: { company: _vm.company },
            on: {
              updated: function ($event) {
                return _vm.$apollo.queries.requestsCount.refetch()
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }